import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse } from "../../Orchestrator/Types/Index";
import { IBookingRequest, IBookingResponse, IOfferAddToBookingRequest } from "../../Orchestrator/Types/Types/BookingTypes";

export async function postBooking(
    bookingRequest: IBookingRequest
): Promise<IApiResponse<IBookingResponse>> {
    // Construct the endpoint with the booking ID
    const ENDPOINTS = await getEndpoints();
    const endpoint = `${ENDPOINTS.postBooking}`;

    // Make the API request using the constructed endpoint and bookingRequest
    return await apiRequest<IBookingResponse>(endpoint, 'POST', {
        body: JSON.stringify(bookingRequest),
    });
}


export async function addOfferToBooking(
    bookingId: string,
    bookingRequest: IOfferAddToBookingRequest
): Promise<IApiResponse<IBookingResponse>> {
    // Construct the endpoint with the booking ID
    const ENDPOINTS = await getEndpoints();
    const endpoint = `${ENDPOINTS.addBookOfferToBookingAPI(bookingId)}`;

    // Make the API request using the constructed endpoint and bookingRequest
    return await apiRequest<IBookingResponse>(endpoint, 'POST', {
        body: JSON.stringify(bookingRequest),
    });
}
